export default "__VITE_ASSET__SVfbjd4Z__"